var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaginationLeftArrowCircle = function SvgPaginationLeftArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 11,
    transform: "matrix(-1 0 0 1 12 12)",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3721 15.6279L8.74419 12L12.3721 8.37207L13.0086 9.00855L10.4839 11.5544H16V12.4455H10.4839L13.0298 14.9914L12.3721 15.6279Z",
    fill: "currentColor"
  })));
};

export default SvgPaginationLeftArrowCircle;